module.exports = __webpack_public_path__ + "static/board-14-286ac24a193df528d5a3d68a9b283793.jpg";